import { ReactElement } from "react";
import HealthIndicator from "@common/components/ui/health/HealthIndicator";
import { getCopyFromHealth } from "@common/components/ui/health/HealthIndicator/utils";
import { IHealthStatusProps } from "./types";
import { useStyles } from "./HealthStatus.styled";
import { Text } from "@mantine/core";

export default function HealthStatus({
  health,
  displayHealth,
  title,
  subtitle,
  mb,
  mt,
  indicatorSize,
}: IHealthStatusProps): ReactElement {
  const { classes } = useStyles({ health, mb, mt });

  return (
    <div
      className={classes.wrapper}
      role="status"
      title={health && !displayHealth ? getCopyFromHealth(health) : undefined}
    >
      {health && (
        <div className={classes.icon}>
          <HealthIndicator health={health} size={indicatorSize} />
        </div>
      )}

      {health && displayHealth && (
        <Text className={classes.text} fz="sm" ml="xs">
          {getCopyFromHealth(health)}
        </Text>
      )}

      {title && (
        <Text className={classes.text} c="gray.9" fz="sm" ml="xs">
          {title}
        </Text>
      )}

      {subtitle && (
        <Text className={classes.text} c="gray.9" fz="sm" ml="xs">
          ({subtitle})
        </Text>
      )}
    </div>
  );
}
